import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-filter-element',
    template: '',
    styleUrls: [],
    standalone: true,
})
export abstract class FilterElementComponent {
    // By default, a filter should be full-width on mobile and half-width on desktop.
    @Input()
    @HostBinding('class.full-width')
    public fullWidth = false;
}
